module.exports = __webpack_public_path__ + "media/images/hankyu_hakone_th01-e4234c44d18fb4135454abc4c72400a1.jpg";